export function isValidIPv4(value: string): boolean {
    const parts = value.split(".");
    if (parts.length !== 4) {
        return false;
    }
    return parts.every((part) => /^\d{1,3}$/.test(part) && Number(part) >= 0 && Number(part) <= 255);
}

export function isPositiveInteger(value: string): boolean {
    return /^\d+$/.test(value) && Number(value) > 0;
}

export function isIntegerInRange(value: string, min: number, max: number): boolean {
    return /^\d+$/.test(value) && Number(value) >= min && Number(value) <= max;
}

const HOST_NAME_REGEX = /^(?![-.])[a-zA-Z0-9-]{1,63}(?:\.(?!-)[a-zA-Z0-9-]{1,63})*(?<!-)$/;

export function isValidHostName(value: string): boolean {
    return value.length <= 253 && HOST_NAME_REGEX.test(value);
}
